import { MessageCircle } from "lucide-react";
import { WA_DEFAULT_MSG, waLink } from "@/data/site";
import api from "@/lib/api";

const VARIANTS = {
  gold: "bg-gold text-obsidian hover:shadow-[0_0_30px_rgba(212,175,55,0.45)]",
  outline: "border border-gold/60 text-gold hover:bg-gold/10",
  ivory: "bg-stone-100 text-obsidian hover:bg-gold-glow",
};

export default function WhatsAppCTA({
  label = "WhatsApp Us",
  message = WA_DEFAULT_MSG,
  context,
  variant = "gold",
  className = "",
  testId = "whatsapp-cta",
  icon = true,
}) {
  const handle = () => {
    api
      .post("/enquiries", { context: context || label, page: window.location.pathname })
      .catch(() => {});
    window.open(waLink(message), "_blank", "noopener");
  };

  return (
    <button
      onClick={handle}
      data-testid={testId}
      className={`inline-flex items-center justify-center gap-2.5 rounded-full px-7 py-3.5 text-xs font-semibold uppercase tracking-[0.18em] transition-all duration-300 hover:-translate-y-0.5 ${VARIANTS[variant]} ${className}`}
    >
      {icon && <MessageCircle className="h-4 w-4" />}
      {label}
    </button>
  );
}
